import React from 'react';
import { useSirenEntity } from '~/utility/BinSentry-ui-utility';
import { Link } from '~/lib/bn-material-ui';

export function BinLink({ binHref, ...linkProps }) {
  const { entity: binEntity } = useSirenEntity({ href: binHref });

  if (!binEntity) {
    return null;
  }

  return (
    <Link
      href={`/bins/show?binId=${encodeURIComponent(binHref)}`}
      {...linkProps}
    >
      {binEntity.properties.name}
    </Link>
  );
}
